// extracted by mini-css-extract-plugin
export default {"btn":"GEBrJwfDtCeKKBayERfN","email":"ikc8i3avCTfZFNK9sOle","apple":"OHz4sgMbnAgUwXkmey39"};